import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledTableOfContents = styled.section`
  display: flex;
  align-items: flex-start;
  column-gap: ${toRem(24)} !important;

  @media ${baseVariables.mediaQuery.md} {
    column-gap: ${toRem(64)} !important;
  }
  .toc-divider {
    width: ${toRem(1)};
    min-height: ${toRem(346)};
    background-color: ${baseVariables.color.neutral30};
    flex-shrink: 0;
  }

  .toc-content {
    display: flex;
    flex-direction: column;
    row-gap: ${toRem(24)};
    min-width: 0;
  }

  .toc-list {
    list-style: none !important;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: ${toRem(16)};
  }

  .toc-item {
    width: fit-content;
  }

  .toc-link {
    display: inline-flex;
    align-items: center;
  }

  @media ${baseVariables.mediaQuery.sm} {
    column-gap: ${toRem(20)};

    .toc-divider {
      min-height: ${toRem(280)};
    }
  }
`;
